import React from 'react';
import { Link, NavLink, useNavigate as useRouterNavigate } from 'react-router-dom';
import { useI18n } from '../context/I18nContext';

function prefix(lang, to) {
  if (!lang || lang === 'en' || typeof to !== 'string') return to;
  if (!to.startsWith('/')) return to; // relative link, leave alone
  if (to.startsWith('//') || to.startsWith('http')) return to;
  // avoid double prefixing
  const parts = to.split('/').filter(Boolean);
  if (parts[0] && parts[0].length === 2 && parts[0] === lang) return to;
  return `/${lang}${to === '/' ? '' : to}`;
}

/** Drop-in replacement for react-router's <Link> that prefixes the current language. */
export function LLink({ to, ...rest }) {
  const { lang } = useI18n();
  return <Link to={prefix(lang, to)} {...rest} />;
}

/** Drop-in replacement for react-router's <NavLink>. */
export function LNavLink({ to, ...rest }) {
  const { lang } = useI18n();
  return <NavLink to={prefix(lang, to)} {...rest} />;
}

/** useNavigate replacement that prefixes the current language. */
export function useLocalizedNavigate() {
  const nav = useRouterNavigate();
  const { lang } = useI18n();
  return (to, opts) => {
    if (typeof to === 'string') return nav(prefix(lang, to), opts);
    return nav(to, opts);
  };
}
